import React from "react";
import "./sign.less";
import { withRouter } from "react-router";
import { setHeader } from "@/util/set-header";
import { Button, NoticeBar, Radio, Toast } from "antd-mobile";
import { PhotoProvider, PhotoConsumer } from 'react-photo-view';
import 'react-photo-view/dist/index.css';
import ReactDOM from "react-dom";
import { contractDetailApi } from "@/api/sany";


@(withRouter as any)
export default class SignDetail extends React.Component<any,any> {
  signBody!: any
  constructor(prop: any) {
    super(prop)
    this.state = {
      notice: '为了保障准时入住，请及时签约~',
      checked: false,
      detail: {},
      bodyHeight: document.documentElement.clientHeight * 3 / 4
    }
    this.signBody = React.createRef()
    this.leftClick = this.leftClick.bind(this)
    this.goHomePage = this.goHomePage.bind(this)
    this.toSignClick = this.toSignClick.bind(this)
  }

  componentDidMount() {
    let title = '签约'
    // let height = document.documentElement.clientHeight - (ReactDOM.findDOMNode(this.signBody.current) as any).getBoundingClientRect().top - 50
    setHeader({title: title, leftToHome: this.goHomePage, leftClick: this.leftClick})
    // this.setState({
    //   bodyHeight: height
    // })
    this.fetchDetail()
  }

  leftClick() {
    //返回App
    const { history } = this.props
    if (history.length > 1) {
      history.goBack()
    } else {
      if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('');
      }
    }
  }

  goHomePage() {
    this.props.history.replace('/sany/dorm-list')
  }

  async fetchDetail() {
    const contract_id = this.props.location.state.contractId
    Toast.loading('加载中...')
    const {data} = await contractDetailApi({contract_id})
    Toast.hide()
    if (data.code === 'SUCCESS') {
      // this.state.detail = data.data

      let title = '签约'
      let height = document.documentElement.clientHeight - (ReactDOM.findDOMNode(this.signBody.current) as any).getBoundingClientRect().top - 50
      let notice = ''
      if (!data.data.is_sign) {
        // title = '合同详情'
        title = '详情'
        notice = '为了保障准时入住，请及时签约~'
      } else {
        height += 50
        notice = '签约已完成'
      }
      console.log('xxxxxx', height)
      setHeader({title: title, leftToHome: this.goHomePage, leftClick: this.leftClick})
      this.setState({
        bodyHeight: height,
        notice,
        detail: data.data
      })
    } else {
      Toast.info(data.msg, 1.5, ()=> {
        this.leftClick()
      })
    }
  }

  // 滚动通知栏
  noticeBarComponent() {
    return <NoticeBar marqueeProps={{ loop: true, style: { padding: '0 7.5px' } }}>{this.state.notice}</NoticeBar>
  }

  // 构建图片数组
  attachmentImageList() {
    const imgs: [] = this.state.detail.file_name ?? []
    return (
      <PhotoProvider>
      {imgs.map((item, index) => (
        <PhotoConsumer key={index} src={item} intro={item}>
          <img src={item} alt="" style={{width: '47px', height: '55px'}}/>
        </PhotoConsumer>
      ))}
    </PhotoProvider>
    )
  }

  clickRadio(e: any) {
    this.setState({
      checked: e.target.checked
    })
  }

  toSignClick() {
    this.props.history.push({pathname: '/sany/user-sign', state: {contractId: this.state.detail.id, num: this.state.detail.num}})
  }

  render() {
    return (
      <div className="sign-body">
        <div className="sign" ref={this.signBody} style={{height: this.state.bodyHeight}}>
          {this.state.notice.length > 0 ? this.noticeBarComponent() : null}
          <div className="header">
            <span style={{color: '#515151', fontSize: '14px'}}>{this.state.detail.title}</span>
            <span style={{color: '#797979', fontSize: '12px'}}>{this.state.detail.code}</span>
          </div>
          <div className="part-ab">
            <span className="font-1" style={{lineHeight: '18px'}}>{this.state.detail.contract_name==='公约'? '为加强宿舍环境管理，创造文明、整洁、温馨、和谐的居住境，特制定如下宿舍管理文明公约。'
            : '为加强宿舍的管理，为员工提供一个良好的生活环境，经出租方、承租方双方平等协商一致，就入住事项共同签订本协议。'}</span>
            { this.state.detail.contract_name==='公约'? null: 
             <span className="font-1" style={{lineHeight: '18px'}}>出租方：<span className="font-2">{this.state.detail.company}</span></span>
            }
            { this.state.detail.contract_name==='公约'? null: 
            <span className="font-1" style={{lineHeight: '18px'}}>承租方(部门或单位)：<span className="font-2">{this.state.detail.depart_name}</span></span>
            }
            { this.state.detail.contract_name==='公约'? null: 
              <span className="font-1" style={{lineHeight: '18px'}}>承租人姓名：<span className="font-2">{this.state.detail.username}</span></span>
            }
            { this.state.detail.contract_name==='公约'? null: 
             <span className="font-1" style={{lineHeight: '18px'}}>身份证号码：<span className="font-2">{this.state.detail.id_no}</span></span>
            }
          </div>
          <div className="part-info">
            <span className="font-1" style={{fontWeight: 'bold', lineHeight: '30px'}}> {this.state.detail.contract_name==='公约'? '一、居住信息：'
            : '一、出租方提供下列宿舍给承租人居住：'}</span>
            { this.state.detail.contract_name==='公约'? 
             <span className="font-1" style={{lineHeight: '18px'}}>园区：<span className="font-2">{this.state.detail.store_name}</span></span>
            : 
             null
            }
            { this.state.detail.contract_name==='公约'? 
             <span className="font-1" style={{lineHeight: '18px'}}>住宿人员姓名：<span className="font-2">{this.state.detail.username}</span></span>
            : 
             null
            }
            { this.state.detail.contract_name==='公约'? 
             <span className="font-1" style={{lineHeight: '18px'}}>联系电话：<span className="font-2">{this.state.detail.phone}</span></span>
            : 
             null
            }
            { this.state.detail.contract_name==='公约'? 
             <span className="font-1" style={{lineHeight: '18px'}}>住宿人员工号：<span className="font-2">{this.state.detail.num}</span></span>
            : 
             null
            }
            { this.state.detail.contract_name==='公约'? 
             <span className="font-1" style={{lineHeight: '18px'}}>身份证号码：<span className="font-2">{this.state.detail.id_no}</span></span>
            : 
             null
            }
            { this.state.detail.contract_name==='公约'? 
             <span className="font-1" style={{lineHeight: '18px'}}>住宿人员部门：<span className="font-2">{this.state.detail.depart_name}</span></span>
            : 
             null
            }
            <span className="font-1">宿舍地址：<span className="font-2">{this.state.detail.store_name}{this.state.detail.building_no}{this.state.detail.floor}{this.state.detail.room_no}</span></span>
            <div className="part-row" style={{justifyContent: 'flex-start'}}>
              <span className="font-1">房号：<span className="font-2">{this.state.detail.room_no}</span></span>
              <span className="font-1" style={{marginLeft: '50px'}}>房型：<span className="font-2">{this.state.detail.room_type_name}</span></span>
            </div>
            <span className="font-1" style={{fontWeight: 'bold', lineHeight:'30px'}}>{this.state.detail.contract_name==='公约'? '二、费用管理'
            : '二、扣费方式'}</span>
            <span className="font-1" style={{lineHeight: '30px'}}>扣费方式：<span className="font-3">{this.state.detail.pay_type_name}</span></span>
            <span className="font-1" style={{fontWeight: 'bold', lineHeight: '30px'}}>{this.state.detail.contract_name==='公约'? null
            : '三、租约信息：'}</span>
            <div className="part-row">
              <div className="my-row" style={{flex: 7}}>
                <div className="font-1" style={{width: '75px'}}>租期起止：</div>
                <div className="font-3">{this.state.detail.start_day} 至 {this.state.detail.end_day}</div>
              </div>
              <div style={{flex: 3}}>
                <span className="font-1">押金：</span>
                <span className="font-3">{this.state.detail.deposit}元</span>
              </div>
            </div>
            <div className="part-row">
              <div className="my-row" style={{flex: 7}}>
                <div className="font-1" style={{width: '75px'}}>结算方式：</div>
                <span className="font-3">{this.state.detail.settlement_way_info}</span>
              </div>
            </div>
            <div className="part-row">
              <div className="my-row" style={{flex: 7}}>
                <div className="font-1" style={{width: '75px'}}>房费：</div>
                <span className="font-3">{this.state.detail.room_fee}元/月</span>
              </div>
              <div style={{flex: 3}}>
                <span className="font-1">公司支付：</span>
                <span className="font-3">{this.state.detail.depart_room_fee}</span>
              </div>
            </div>
            <div className="part-row">
              <div className="my-row" style={{flex: 7}}>
                <div className="font-1" style={{width: '75px'}}>网络费：</div>
                <span className="font-3">{this.state.detail.internet_fee}元/月</span>
              </div>
              <div style={{flex: 3}}>
                <span className="font-1">公司支付：</span>
                <span className="font-3">{this.state.detail.depart_internet_fee}</span>
              </div>
            </div>
            <div className="part-row">
              <div className="my-row" style={{flex: 7}}>
                <div className="font-1" style={{width: '75px'}}>有线电视费：</div>
                <span className="font-3">{this.state.detail.tv_fee}元/月</span>
              </div>
              <div style={{flex: 3}}>
                <span className="font-1">公司支付：</span>
                <span className="font-3">{this.state.detail.depart_tv_fee}</span>
              </div>
            </div>
            <div className="part-row">
              <div className="my-row" style={{flex: 7}}>
                <div className="font-1" style={{width: '75px'}}>冷水费：</div>
                <span className="font-3">{this.state.detail.cold_water_fee}元/吨 (实时价)</span>
              </div>
              <div style={{flex: 3}}>
                <span className="font-1">公司支付：</span>
                <span className="font-3">{this.state.detail.cold_water_fee_depart === '0' ? '否' : '是'}</span>
              </div>
            </div>
            <div className="part-row">
              <div className="my-row" style={{flex: 7}}>
                <div className="font-1" style={{width: '75px'}}>中水费：</div>
                <span className="font-3">{this.state.detail.recycle_cold_water_fee}元/吨 (实时价)</span>
              </div>
              <div style={{flex: 3}}>
                <span className="font-1">公司支付：</span>
                <span className="font-3">{this.state.detail.recycle_cold_water_fee_depart === '0' ? '否' : '是'}</span>
              </div>
            </div>
            <div className="part-row">
              <div className="my-row" style={{flex: 7}}>
                <div className="font-1" style={{width: '75px'}}>热水费：</div>
                <span className="font-3">{this.state.detail.hot_water_fee}元/吨 (实时价)</span>
              </div>
              <div style={{flex: 3}}>
                <span className="font-1">公司支付：</span>
                <span className="font-3">{this.state.detail.hot_water_fee_depart === '0' ? '否' : '是'}</span>
              </div>
            </div>
            <div className="part-row">
              <div className="my-row" style={{flex: 7}}>
                <div className="font-1" style={{width: '75px'}}>电费：</div>
                <span className="font-3">{this.state.detail.electric_fee}元/度 (实时价)</span>
              </div>
              <div style={{flex: 3}}>
                <span className="font-1">公司支付：</span>
                <span className="font-3">{this.state.detail.electric_fee_depart === '0' ? '否' : '是'}</span>
              </div>
            </div>
            {this.state.detail.img ? <div className="attachment">
              <span className="font-1">附件：</span>
              {this.attachmentImageList()}
            </div>: null}
          </div>
          {/* <div className="part-info">
            <span className="font-1" style={{fontWeight: 'bold', lineHeight: '30px'}}>四、住宿须知：</span>
            <p className="font-5" style={{lineHeight: '20px'}}>
              1、服从公司安排、监督和管理。<br/>
              2、员工入住须经批准，服从宿舍管理人员安排，按指定的房间、床位入住，不得擅自更换房间、铺位。<br/>
              3、宿舍房间及床位只限员工本人使用，员工不得将房间或床位转租或出借给他人使用，一经发现，立即取消住宿资格，并记入公司诚信档案，并追究其相关责任。<br/>
              4、不允许留宿外来人员。<br/>
              5、住宿员工离职(包括自离、辞职、免职等)，须到宿舍服务前台办理退住手续后方可办理离职手续。<br/>
              6、未经允许禁止私自修改房间门锁设置、私自重置或改装门锁，否则拉入入住黑名单，永久禁止入住，处罚相应的费用，并赔偿相关维修费用。
            </p>
            <span className="font-1" style={{fontWeight: 'bold', lineHeight: '30px'}}>五、设备设施管理：</span>
            <p className="font-5" style={{lineHeight: '20px'}}>
              1、宿舍内非私物品属于公司公共资产，员工不得私自拆换、占用、损坏。<br/>
              2、宿舍内非私设施，非自然损坏的由责任人照价赔偿，对于个别无法明确是人为损坏或自然损坏的情况，由楼栋管家与维修人员共同界定责任主体并明确费用承担的责任主体。
            </p>
            <span className="font-1" style={{fontWeight: 'bold', lineHeight: '30px'}}>六、承租方应遵守以下约定：</span>
            <p className="font-5" style={{lineHeight: '20px'}}>
              1、严禁在宿舍内进行赌博、嫖娼、宣传迷信等其他有伤风化的活动，违者对事件相关责任人处以 500 元/次罚款，情节严重者，送公安机关处理。<br/>
              2、严禁在宿舍内酗酒、打架、斗殴或侮辱他人，违者对事件责任人处以 500 元/ 次罚款，情节严重者，送交公安机关处理。<br/>
              3、作为公共场所和休息场所，员工应自觉保持宿舍安静，严禁串门，不得大声喧哗，晚上22时后停止一切娱乐活动(特殊情况除外)，违者对事件相关责任方处以300元/次罚款。<br/>
              4、住宿员工不得于宿舍区室内外墙壁、橱柜、门窗随意张贴字画或钉挂物品，如造成墙体损坏或污渍的，员工或所在事业部需承担相应复原成本。<br/>
              5、严禁在宿舍内饲养动物，严禁向窗外泼水、乱扔杂物。住宿员工不得在公共走廊、楼梯及其他公共场所堆放物品，违者处以 300 元/次罚款。<br/>
              6、垃圾应在园区指定位置进行倾倒，不得将垃圾放在楼道、楼梯间等非垃圾回收区域，违者处以 200 元/次罚款。<br/>
              7、住宿员工洗晒衣物须在指定区域或宿舍阳台晾晒，不得随意在走廊、过道、卫生间及其它公共区域晾挂，违者处以 200 元/次罚款。<br/>
              8、为确保宿舍安全与卫生，除洗衣机外，员工不得在宿舍内使用电磁炉、电炉等高功率设备，不能在宿舍内做饭、煮火锅，违者取消入住资格，并没收器具。所有宿舍的照明灯具及线路必须由电工安装、维修，禁止乱接临时电线、不准超负荷用电，不准用不符合规定的装置，违者处以 500 元/次的罚款。<br/>
              9、由于本人私接电源、插座而引起的火灾，取消住房资格，造成损失的一律由责任人承担，造成严重后果的追究相关人员法律责任。
              10、住宿员工应自觉保持宿舍干净整洁卫生，公司定期组织宿舍6s检查，不符合要求的视情况给予200-500元/次的罚款，多人入住的处罚责任人。
            </p>
            <span className="font-1" style={{fontWeight: 'bold', lineHeight: '30px'}}>七、</span>
            <p className="font-5" style={{lineHeight: '20px'}}>
              出租方虽对宿舍进行相应服务及管理，但是不对住宿人的财产与人身损害承担责任。承租方住宿期间发生财物丢失、损坏或者人身损害的，应自行承担责任或向肇事者索赔，出租方不承担责任。
            </p>
            <span className="font-1" style={{fontWeight: 'bold', lineHeight: '30px'}}>八、</span>
            <p className="font-5" style={{lineHeight: '20px'}}>
            出租方与承租方需共同确定室内装修是否完好、设施设备是否功能齐全并签订本协议书。承租方退房时，出租方对装修与设施设备与承租方入住时进行比对。若有损坏，照价赔偿。
            </p>
            <span className="font-1" style={{fontWeight: 'bold', lineHeight: '30px'}}>九、</span>
            <p className="font-5" style={{lineHeight: '20px'}}>
              本协议一式二份，出租方、承租方双方各执一份。本协议自签订之日起生效，双方应遵照执行本协议。
            </p>
            <span style={{color: '#333333', fontSize: '13px',lineHeight: '18px', paddingTop: '20px'}}>出租方：<span className="font-2">{this.state.detail.company}</span></span>
            <div className="attachment">
              <span style={{color: '#333333', fontSize: '13px',lineHeight: '18px'}}>承租方：</span>
              {this.state.detail.is_sign ? <img src={this.state.detail.sign_img} alt="" style={{width: '150px', height: '70px'}}/> : null}
            </div>
            <span style={{color: '#333333', fontSize: '13px',lineHeight: '18px', paddingTop: '20px'}}>日期：{this.state.detail.sign_time}</span>
          </div> */}
          <div className="part-info">
            <div className="conterInfo"  dangerouslySetInnerHTML = {{__html:this.state.detail.contract_content}}></div>
            <span style={{color: '#333333', fontSize: '13px',lineHeight: '18px', paddingTop: '20px'}}>出租方：<span className="font-2">{this.state.detail.company}</span></span>
            <div className="attachment">
              <span style={{color: '#333333', fontSize: '13px',lineHeight: '18px'}}>承租方：</span>
              {this.state.detail.is_sign ? <img src={this.state.detail.sign_img} alt="" style={{width: '150px', height: '70px'}}/> : null}
            </div>
            <span style={{color: '#333333', fontSize: '13px',lineHeight: '18px', paddingTop: '20px'}}>日期：{this.state.detail.sign_time}</span>
          </div>
        </div>
        {!this.state.detail.is_sign ? <div className="sign-bottom">
          <Radio className="my-radio" checked={this.state.checked} onChange={e => this.clickRadio(e)}>我已阅读员工宿舍协议</Radio>
          <Button className="sign-btn" disabled={!this.state.checked} onClick={this.toSignClick}>开始签约</Button>
        </div>: null}
      </div> 
    )
  }
}